// extracted by mini-css-extract-plugin
export default {"title":"InnerPageTitle_title__31qUC"};